import Utils from '../common/Utils';
import Swiper, {Navigation, Pagination} from 'swiper';
import {API_DOMAIN, GLOBAL_PATH, STORE } from '../common/Model';

export default class Guide {
	constructor(_config) {

		this.config = _config;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'guidebook',
			locale : this.config.locale,
			country : this.config.country
		};
		this.guideApiUrl = GLOBAL_PATH(_option);
		this.TITLE = _config.tabConfig.tabCmpick.cmpickGuidebook.title ? _config.tabConfig.tabCmpick.cmpickGuidebook.title : STORE.title.guide;
		let _optionUrl = {
			type: 'url',
			service : this.config.service,
			menu : 'guidebook',
			locale : this.config.locale,
			country : this.config.country
		};
		this.guidePathUrl = GLOBAL_PATH(_optionUrl);
	}
	init() {
		if( Utils.isEmptyObject(STORE.data.guidebook) ) {
			this.get();
		} else {
			this.render(STORE.data.guidebook);
		}
	}

	get() {
		const _this =  this;
		fetch(this.guideApiUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json.list;
			} else {
				_resData = data.list;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.guidebook = _resData;
			_this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
		});
		/*$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${this.guideApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json.list;
			} else {
				_resData = data.list;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.guidebook = _resData;
			this.render(_resData);
		});*/
	}
	render(data) {
		const wrapper = document.querySelector('.guide-wrapper');
		const tmpl = this.templ(data); // isActive:true 일 경우에만 렌더 하자
		if(data && data.length > 0) wrapper.innerHTML = tmpl;

		this.addEvent();
	}

	templ(_d){
		let _title = `<a href="${this.guidePathUrl}index"><h3>${this.TITLE}</h3><i class="icon-more"></i></a>`;
		return `
			<header class="guide-header">
				${_title}
				<div class="swiper-pagination"></div>
			</header>
			<article class="guide-list swiper" ${this.config.isRtl ? 'dir="rtl"' : '' }>
				<div class="swiper-wrapper">
					${_d.map( (item, index) => {
						return this.listTempl(item);
					}).join('')}
				</div>
			</article>
			<div class="swiper-button-prev"></div>
			<div class="swiper-button-next"></div>`;
	}

	listTempl(_a) {
		return `
		<div class="guide-item swiper-slide">
		   <a class="guide-link" href="${this.guidePathUrl}view?title=${encodeURI(_a.title)}">
				<div class="guide-thumb">${_a.img ? `<img src="${_a.img}" alt="">` : ``}</div>
				<div class="guide-text">
					<div class="guide-title">${_a.title}</div>
					<div class="guide-desc"></div>
				</div>
			</a>
		</div>`;
	}

	addEvent() {
		let guideSwiper = new Swiper('.guide-list', {
			modules: [Navigation, Pagination],
			slidesPerView: 'auto',
			// slidesPerGroup: 'auto',
			spaceBetween: 1,
			loop: false,
			freeMode: true,
			freeModeMomentumBounce: false,
			// loopAdditionalSlides: 6,
			pagination: {
				el: '.guide-wrapper .swiper-pagination',
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: '.guide-wrapper .swiper-button-next',
				prevEl: '.guide-wrapper .swiper-button-prev'
			},
			breakpoints: {
				959: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					loop: false
				},
			}
		});

		if (guideSwiper.slides.length <= 3) {
			const bullets = document.querySelectorAll(".guide-wrapper .swiper-pagination-bullets");
			bullets.forEach( el => {
				el.classList.add('disabled');
			});
		}

		/*window.addEventListener('resize', (evt) => {
			onWindowResize();
		});
		function onWindowResize () {
			guideSwiper();
		}*/

	}

}